export { default as ChatMessageShape } from "./ChatMessageShape";
export { default as MeetingAccessRequestMessageShape } from "./MeetingAccessRequestMessageShape";
